import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { CollectionInput, LabelledInput } from '@tg/core/components';

const CollectionField = ({
  required,
  name,
  errors,
  id,
  translationKey,
  disabled,
  defaultValue,
  control,
  resource,
  multiple,
  search,
  useName,
  status,
}) => {
  const { t } = useTranslation('forms');

  const label = t(`labels.${translationKey}`);
  const placeholder = t(`placeholders.${translationKey}`);
  const fieldId = `${id}.${name}`;

  return (
    <LabelledInput
      id={fieldId}
      label={label}
      error={errors && t(`validations.${errors.message.key}`)}
      required={required && !disabled}
    >
      <Controller
        as={
          <CollectionInput
            id={fieldId}
            resource={resource}
            multiple={multiple}
            search={search}
            useName={useName}
          />
        }
        status={status}
        name={fieldId}
        control={control}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
      />
    </LabelledInput>
  );
};

CollectionField.propTypes = {
  required: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  errors: PropTypes.object,
  id: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  control: PropTypes.any.isRequired,
  resource: PropTypes.oneOf([
    'address_countries',
    'domiciles',
    'industry_sectors',
    'employee_benefit_types',
    'employee_benefits',
    'contract_types',
    'attendance_types',
    'currencies',
  ]).isRequired,
  multiple: PropTypes.bool,
  search: PropTypes.bool,
  useName: PropTypes.bool,
  status: PropTypes.bool,
};

CollectionField.defaultProps = {
  errors: null,
  defaultValue: '',
  multiple: false,
  search: false,
  useName: false,
  disabled: false,
  status: false,
};

export default CollectionField;
